<template>
  <d-container
    fluid
    class="pl-0 pr-0 pl-md-2 pr-md-2">
    <d-row
      class="main-wrapper mr-0 ml-0"
      style="max-width: 100%;">
      <!-- Main Sidebar -->
      <main-sidebar
        :items="sidebarItems" />

      <d-col
        class="main-content ml-auto mr-auto"
        tag="main"
        cols="12">
        <!-- Content -->
        <slot />
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import getSidebarItems from '@/data/sidebar-nav-items';
import MainSidebar from '@/components/layout/MainSidebar.vue';

export default {
  name: 'main-view',
  components: {
    MainSidebar
  },
  data() {
    return {
      sidebarItems: getSidebarItems(),
    };
  },
};
</script>

<style lang="scss">
.main-wrapper {
  padding-left: 240px;
}

.main-content {
  max-width: 1440px;
}

@media screen and (max-width: 1200px) {
  .main-content {
    padding-top: 3.75rem !important;
  }

  .main-wrapper {
    padding-left: 0;
  }
}
</style>
